import * as Translation from '../i18n/locale-de.json';


export function translate(path:any){
    const splitPath = path.split('.');
    return splitPath.reduce((acc:any,curr:any) => {
        return (typeof acc !== 'undefined') ?  acc[curr] : '' ;
    }, Translation) || '';
};